/**
 * isiXhosa: Dashboard
 *
 * What this file covers: The dashboard and its first-run setup checklist.
 *
 * Tone: Encouraging and brief. Tell the business what is happening and what to do next, in a few words.
 *
 * isiXhosa: Everyday isiXhosa as used in South African business. Keys not translated yet fall back to English,
 * so a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const dashboard: Catalog = {
  'dashboard.welcome': 'Wamkelekile',
  'dashboard.title': 'Wamkelekile, {{name}}',
  'dashboard.title.anonymous': 'Wamkelekile kwakhona',
  'dashboard.verifyBanner.title': 'Qinisekisa i-imeyile yakho',
  'dashboard.verifyBanner.cta': 'Qinisekisa ngoku →',
  'dashboard.metrics.unread': '{{count}} engafundwanga',
  'dashboard.trend.percent': '{{value}}% xa kuthelekiswa nangoku izolo',
  'dashboard.trend.points': '{{value}} amanqaku xa kuthelekiswa nangoku izolo',
  'dashboard.trend.flat': 'Kuzinzile',
  'dashboard.trend.flat.tooltip': 'Utshintsho oluncinci kwiiyure ezingama-24 ezidlulileyo.',
  'dashboard.trend.tooltip': '{{current}} kwiiyure ezingama-24 ezidlulileyo, xa kuthelekiswa no-{{previous}} kwiiyure ezingama-24 ngaphambili.',
  'dashboard.metrics.deliveryRate': 'Izinga lokuhanjiswa',
  'dashboard.metrics.deliveryHint': 'Kwemiyalezo ethunyelwe kwiiyure ezingama-24 ezidlulileyo',
  'dashboard.metrics.deliveryNone': 'Akukho miyalezo ithunyelweyo okwangoku',
  'dashboard.viewMessages': 'Jonga imiyalezo',
  'dashboard.recent.title': 'Iincoko zakutshanje',
  'dashboard.recent.openInbox': 'Vula ibhokisi yokungena →',
  'dashboard.recent.empty': 'Akukho ncoko okwangoku.',
  'dashboard.recent.noMessages': 'Akukho miyalezo',
  'dashboard.quickActions.title': 'Izenzo ezikhawulezayo',
  'dashboard.quickActions.addContacts': 'Yongeza abaqhagamshelwana nabo',
  'dashboard.quickActions.newTemplate': 'Itemplethi entsha',
  'dashboard.quickActions.newBroadcast': 'Usasazo olutsha',
  'dashboard.quickActions.buildFlow': 'Yakha ukuhamba',
  'dashboard.quickActions.attachNumber': 'Qhoboshela inani',
  'dashboard.quickActions.topUp': 'Gcwalisa isipaji',
  'setup.dismissed': 'Uluhlu lokuseta lufihliwe. Ungalubuyisa kwiiSetingi → Imbonakalo.',
  'setup.progress.badge': '{{done}} kwi-{{total}} egqityiweyo',
  'setup.step.done': 'Igqityiwe',
  'setup.step.todo': 'Ayikenziwa',
  'setup.restore': 'Bonisa uluhlu lokuseta',
  'setup.restore.hint': 'Buyisa amanyathelo okuqala kwideshbhodi.',
  'dashboard.sendBlock.title': 'Imiyalezo yakho ayihanjiswa',
  'dashboard.sendBlock.ACCOUNT_NOT_PAYABLE': 'I-WhatsApp iyala yonke imiyalezo ku-{{number}} ngenxa yengxaki yentlawulo kwicala lethu. Siyayilungisa, kwaye akufuneki wenze nto kwa-Meta.',
  'dashboard.sendBlock.NUMBER_NOT_REGISTERED': 'I-{{number}} ayibhaliswanga kwi-WhatsApp ukuze ithumele, ngoko akukho nto ithunyelweyo ngayo efikayo.',
  'dashboard.sendBlock.META_REFUSED': 'I-WhatsApp iyawala wonke umyalezo ku-{{number}}.',
  'dashboard.sendBlock.alsoOthers': 'Namanye amanani angu-{{count}} achaphazelekile.',
  'dashboard.sendBlock.notCharged': 'Awubizwa ngomyalezo ongahanjiswanga.',
  'dashboard.sendBlock.action': 'Vula Amanani'
};

export default dashboard;
